import React, { Component } from 'react';
import TrackVisibility from 'react-on-screen';

import GoodnightJournal from './components/GoodnightJournal';
import DateHelper from './components/DateHelper';
import AfterInterview from './components/AfterInterview';
import Squadeal from './components/Squadeal';
import EmpowerRetailInvestors from './components/EmpowerRetailInvestors';
import FFFMagazine from './components/FFFMagazine';
import FFFDashboard from './components/FFFDashboard';

import logo from './assets/images/ohsikpark-logo.png';
import './assets/css/App.css';

import ReactGA from 'react-ga';
ReactGA.initialize('UA-123951022-1');
ReactGA.pageview(window.location.pathname + window.location.search);

let whoIs = null;

class App extends Component {

  componentDidMount() {
    let project = document.querySelectorAll('.project'),
        project_bg = document.querySelectorAll('.project_bg');

    window.addEventListener('scroll', function() {
      for (let i = 0; i < project.length; i++) {
        project[i].style.transform = 'translateY(' + project[i].getBoundingClientRect().top/60 + '%)';
        project_bg[i].style.transform = 'translateY(' + project[i].getBoundingClientRect().top/30 + '%) rotate(' + (project[i].getBoundingClientRect().top/800 * (180/ Math.PI)) + 'deg)';
      }
    });

    window.addEventListener('load', function() {
      fetch('https://json.geoiplookup.io/?')
        .then(response => {
          return response.json();
        })
        .then(data => {
          whoIs = data.ip;
        });
    });
    document.querySelectorAll('a, #dark_mode_button').forEach(function(elem,index){
       elem.addEventListener('click',function(){
          let myId = elem.id;
          ReactGA.event({
            category: 'click on link',
            action: myId,
            label: whoIs
          });
       },false)
    });

    let d = document.documentElement,
        t = document.querySelectorAll(".dark-theme-button")[0],
        m = localStorage.getItem("nightmode");

    if(m === "true") {
      d.classList.add("night-mode");
    }

    t.addEventListener("click", function(){
      if(d.classList.contains("night-mode")) {
        d.classList.remove("night-mode");
        localStorage.setItem("nightmode", "false");
      } else {
        d.classList.add("night-mode");
        localStorage.setItem("nightmode", "true");
      }
    });
  }

  render() {
    return (
      <div className="App">
        <header className="App-header container">
          <div>
            <a href="/" id="logo"><img src={logo} className="App-logo animated-2" alt="logo" /></a>
          </div>
          <div className="dark-theme-button animated-2" id="dark_mode_button">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" className="crescent">
              <path d="M133.22,155.68c-48.58-0.58-88.31-40.31-88.89-88.89c-0.27-22.55,7.76-43.22,21.22-59.14C66.92,6,65.15,3.63,63.2,4.51C27.85,20.48,3.44,56.39,4.34,97.91c1.16,53.23,44.51,96.59,97.75,97.75c41.52,0.9,77.43-23.5,93.4-58.86c0.88-1.95-1.49-3.73-3.13-2.34C176.43,147.92,155.77,155.95,133.22,155.68z" />
            </svg>
          </div>
        </header>

        <div className="hero container">
          <div className="hero-wrap">
            <h1 className="App-title animated-1"><span role="img" aria-label="Hi">👋</span> Hello, I'm O,<br />a frontend developer.</h1>
          </div>
        </div>

        <TrackVisibility once offset={700}>
          <Squadeal />
        </TrackVisibility>

        <TrackVisibility once offset={700}>
          <EmpowerRetailInvestors />
        </TrackVisibility>

        <TrackVisibility once offset={700}>
          <GoodnightJournal />
        </TrackVisibility>

        <TrackVisibility once offset={700}>
          <AfterInterview />
        </TrackVisibility>

        <TrackVisibility once offset={700}>
          <FFFMagazine />
        </TrackVisibility>

        <TrackVisibility once offset={700}>
          <DateHelper />
        </TrackVisibility>

        <TrackVisibility once offset={700}>
          <FFFDashboard />
        </TrackVisibility>

        <footer className="container">
          <h2>I'm a design-driven front-end developer skilled in building web and mobile apps from concept to scalable products <span role="img" aria-label="Emile">😊</span></h2>
          <div>
            <a href="mailto:o@ohsikpark.com" className="cta-btn" id="contact_me">Email</a> <a href="http://www.github.com/ohsik" className="cta-btn" target="_blank" rel="noopener noreferrer" id="see_more">GitHub</a> <a href="https://www.linkedin.com/in/ohsikpark" className="cta-btn" target="_blank" rel="noopener noreferrer" id="linkedin_link">Linkedin</a>
            <p className="copyright"><small>Designed & built with <span role="img" aria-label="Fire">❤️</span> in 2020</small></p>
          </div>
        </footer>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js